import React from 'react'
import { Link } from 'react-router'
import { getEnvColor, getEnvName, Mtds, WrenchIcon } from 'prove-common'

type AppLogoProps = {
  hidden?: boolean
}

export const AppLogo = ({ hidden }: AppLogoProps) => {
  const envName = getEnvName()
  const envColor = getEnvColor(envName)
  return (
    <Mtds.Logo
      as={Link}
      data-env={import.meta.env.MODE === 'test' ? 'mock' : envName}
      data-color={envColor}
      hidden={hidden}
      to='/home'
    >
      <WrenchIcon weight='fill' /> Prøveadmin
    </Mtds.Logo>
  )
}
